import { createSlice } from '@reduxjs/toolkit';
import { DataService } from '../app/configure/service/deviceservice';
const dataService = new DataService();
// Initialize refreshToken and storedJWTToekn from localStorage if available for backward compitabilty with earlier signage2.0 version using workspaceeffects
const storedJWTToken = dataService.getNATSJwtToken()
    ? dataService.getNATSJwtToken()
    : localStorage.getItem('jwt_token');
const storedRefreshToken = dataService.getNATSRefreshToken()
    ? dataService.getNATSRefreshToken()
    : localStorage.getItem('refresh_token');
const storedRegistered = dataService.isRegistered()
    ? dataService.isRegistered()
    : storedJWTToken != null && storedRefreshToken != null;
const storedDeviceToken = dataService.getDeviceToken();
const initialState = {
    jwtToken: storedJWTToken !== null && storedJWTToken !== void 0 ? storedJWTToken : null,
    refreshToken: storedRefreshToken !== null && storedRefreshToken !== void 0 ? storedRefreshToken : null,
    contextData: null,
    registered: storedRegistered,
    token: storedDeviceToken,
    viewType: null,
    error: null, // { message: string, showClearCache: boolean }
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setJwtToken(state, action) {
            state.jwtToken = action.payload;
            dataService.setNATSJwtToken(action.payload);
        },
        setRefreshToken(state, action) {
            state.refreshToken = action.payload;
            dataService.setNATSRefreshToken(action.payload);
        },
        setContextData(state, action) {
            state.contextData = action.payload;
        },
        setViewType(state, action) {
            state.viewType = action.payload;
        },
        setToken(state, action) {
            state.token = action.payload;
            dataService.setDeviceToken(action.payload);
        },
        isRegistered(state, action) {
            state.registered = action.payload;
            dataService.setRegistered(action.payload);
        },
        setError(state, action) {
            // Map enum keys to i18n keys and handle errorCode
            if (action.payload && action.payload.message) {
                if (action.payload.message === 'REFRESH_API_401') {
                    state.error = Object.assign(Object.assign({}, action.payload), { message: 'common.error.refresh-401' });
                }
                else if (action.payload.message === 'REFRESH_API_OTHER') {
                    state.error = Object.assign(Object.assign({}, action.payload), { message: 'common.error.refresh-other' });
                }
                else if (action.payload.message === 'CONTEXT_API_401') {
                    state.error = Object.assign(Object.assign({}, action.payload), { message: 'common.error.context-401' });
                }
                else if (action.payload.message === 'CONTEXT_API_OTHER') {
                    state.error = Object.assign(Object.assign({}, action.payload), { message: 'common.error.context-other' });
                }
                else {
                    state.error = action.payload;
                }
            }
            else {
                state.error = action.payload;
            }
        },
        clearError(state) {
            state.error = null;
        },
        clearAll(state) {
            state.jwtToken = null;
            state.refreshToken = null;
            state.contextData = null;
            state.viewType = null;
            dataService.removeNATSJwtToken();
            dataService.removeNATSRefreshToken();
            dataService.removeDeviceToken();
        },
    },
});
export const { setJwtToken, setRefreshToken, setContextData, setViewType, setToken, isRegistered, clearAll, setError, clearError, } = authSlice.actions;
export default authSlice;
